export default "__VITE_ASSET__CkAUqVLG__"